<script lang="ts">
    import Fa from 'svelte-fa'
    import type { Schedule } from '../../../modules/schedulerApi/schedules/schedule'
    import { SchedulesRepository } from '../../../modules/schedulerApi/schedules/schedules.repository'
    import { SchedulesService } from '../../../modules/schedulerApi/schedules/schedules.service'

    import CompanySelect from './company-select.svelte'
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    let loaded

    async function evaluateSuccess(ev) {
        if (!(await onboardingOk())) {
            window.self.location.href = '/onboarding'
            return
        }
        window.self.location.href = '/?r=' + new Date().getTime() // window.api.utils.utils.getZanduVersion()
    }

    async function evaluateError(ev) {
        if (ev?.detail === 'Token not allowed for this company.') {
        }
    }

    async function onboardingOk() {
        let onboarding = await window.flags('onboarding')
        if (onboarding === undefined || onboarding === null) {
            try {
                if (self.location.host.includes('prospect.zandu.com.br')) return false
                const schedulerR = new SchedulesRepository()
                const schedulerS = new SchedulesService(schedulerR)
                const schedules: Schedule[] = await schedulerS.getAll()
                const schedulerConfigured = schedules.length > 0
                if (schedulerConfigured) {
                    await window.flags('onboarding', false, true)
                }
                return schedulerConfigured
            } catch (error) {
                return false
            }
        }
        return onboarding
    }

    async function goLogout() {
        await window.api.users.auth.logout(false)
        location.href = '/login'
    }
</script>

<div class="root-company-select-page">
    <div class="box">
        <div class="box_exit">
            <button class="btn btn-outline-secondary btn-sm" on:click={goLogout}><Fa icon={faTimes}></Fa>&nbsp;Sair</button>
        </div>
        <div class="img">
            <img src="/img/logo_full_white.png" alt="" />
        </div>
        {#if !loaded}
            <div class="label">Aguarde...</div>
        {/if}
        <CompanySelect auto={true} bind:loaded on:success={evaluateSuccess} on:error={evaluateError} />
    </div>
</div>

<style>
    .root-company-select-page {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: url('/img/bg_login.png') #333333 center center no-repeat;
        background-size: cover;
        padding: 16px 8px;
    }
    .root-company-select-page .box {
        /* From https://css.glass */
        background: rgba(0, 0, 0, 0.4);
        border-radius: 16px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border: 1px solid rgba(0, 0, 0, 0.06);
        padding: 16px 8px;
        flex: 0 1 750px;
        color: white;
        overflow: hidden;
        position: relative;
    }
    .box .img {
        text-align: center;
    }

    .box .label {
        margin: 16px 0px 8px 0px;
        color: white;
        text-align: center;
    }

    .box_exit {
        text-align: right;
        margin-bottom: 8px;
        cursor: pointer;
        position: absolute;
        right: 16px;
    }
</style>
